import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/cartascorrecoes/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCartasCorrecoes(
  empresa_cnpj,
  id,
  where = {},
  sort = ""
) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      sort ? `&sort=${sort}` : ""
    }`,
    "GET",
    headers
  );
}

export async function createCartaCorrecao(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function sendCartaCorrecao(empresa_cnpj, ccId, body) {
  return search(
    `${path}/send/${ccId}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function downloadCartaCorrecao(empresa_cnpj, ccId) {
  return search(
    `${path}/cce/${ccId}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers
  );
}
